import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rentalInvoiceBillsList: { loading: false, data: null, error: null },
  rentalInvoiceBillsCreate: { loading: false, data: null, error: null },
  rentalInvoiceBillsUpdate: { loading: false, data: null, error: null },
  rentalInvoiceBillsDelete: { loading: false, data: null, error: null },
  rentalReportUpdateStatus: { loading: false, data: null, error: null },

  rentalBillsList: { loading: false, data: null, error: null },
  rentalBillsCreate: { loading: false, data: null, error: null },
  rentalBillsUpdate: { loading: false, data: null, error: null },

};

export const RentalBillsSlice = createSlice({
  name: "rentalbills",
  initialState,
  reducers: {
    // rentalInvoiceBills fetch List
    fetchrentalInvoiceBillsListRequest: (state, action) => {
      state.rentalInvoiceBillsList.loading = true;
      state.rentalInvoiceBillsList.error = null;
    },
    fetchrentalInvoiceBillsListSuccess: (state, action) => {
      state.rentalInvoiceBillsList.data = action.payload;
      state.rentalInvoiceBillsList.loading = false;
      state.rentalInvoiceBillsList.error = null;
    },
    fetchrentalInvoiceBillsListFailure: (state, action) => {
      state.rentalInvoiceBillsList.data = null;
      state.rentalInvoiceBillsList.loading = false;
      state.rentalInvoiceBillsList.error = action.payload;
    },

    // rentalInvoiceBills create
    rentalInvoiceBillsCreateRequest: (state, action) => {
      state.rentalInvoiceBillsCreate.loading = true;
      state.rentalInvoiceBillsCreate.error = null;
    },
    rentalInvoiceBillsCreateSuccess: (state, action) => {
      state.rentalInvoiceBillsCreate.data = action.payload;
      state.rentalInvoiceBillsCreate.loading = false;
      state.rentalInvoiceBillsCreate.error = null;
      state.rentalInvoiceBillsList = addNewrentalInvoiceBillsSuccess(
        action.payload,
        {
          ...state.rentalInvoiceBillsList,
        }
      );
    },
    rentalInvoiceBillsCreateFailure: (state, action) => {
      state.rentalInvoiceBillsCreate.data = null;
      state.rentalInvoiceBillsCreate.loading = false;
      state.rentalInvoiceBillsCreate.error = action.payload;
    },

    // Update
    rentalInvoiceBillsUpdateRequest: (state, action) => {
      state.rentalInvoiceBillsUpdate.loading = true;
      state.rentalInvoiceBillsUpdate.error = null;
    },
    rentalInvoiceBillsUpdateSuccess: (state, action) => {
      state.rentalInvoiceBillsUpdate.data = action.payload;
      state.rentalInvoiceBillsUpdate.loading = false;
      state.rentalInvoiceBillsUpdate.error = null;

      state.rentalInvoiceBillsList = updaterentalInvoiceBillsSuccess(
        action.payload,
        state.rentalInvoiceBillsList
      );
    },
    rentalInvoiceBillsUpdateFailure: (state, action) => {
      state.rentalInvoiceBillsUpdate.data = null;
      state.rentalInvoiceBillsUpdate.loading = false;
      state.rentalInvoiceBillsUpdate.error = action.payload;
    },

    // delete
    rentalInvoiceBillsDeleteRequest: (state, action) => {
      state.rentalInvoiceBillsDelete.loading = true;
      state.rentalInvoiceBillsDelete.error = null;
    },
    rentalInvoiceBillsDeleteSuccess: (state, action) => {
      state.rentalInvoiceBillsDelete.data = action.payload;
      state.rentalInvoiceBillsDelete.loading = false;
      state.rentalInvoiceBillsDelete.error = null;
      state.rentalInvoiceBillsList = removeRentalItem(
        action.payload,
        state.rentalInvoiceBillsList
      );
    },
    rentalInvoiceBillsDeleteFailure: (state, action) => {
      state.rentalInvoiceBillsDelete.data = null;
      state.rentalInvoiceBillsDelete.loading = false;
      state.rentalInvoiceBillsDelete.error = action.payload;
    },

    // rentalReportUpdateStatus
    rentalReportUpdateStatusRequest: (state, action) => {
      state.rentalReportUpdateStatus.loading = true;
      state.rentalReportUpdateStatus.error = null;
    },
    rentalReportUpdateStatusSuccess: (state, action) => {
      state.rentalReportUpdateStatus.data = action.payload;
      state.rentalReportUpdateStatus.loading = false;
      state.rentalReportUpdateStatus.error = null;

      state.rentalInvoiceBillsList = updateRentalReportStatusSuccess(
        action.payload,
        state.rentalInvoiceBillsList
      );
    },
    rentalReportUpdateStatusFailure: (state, action) => {
      state.rentalReportUpdateStatus.data = null;
      state.rentalReportUpdateStatus.loading = false;
      state.rentalReportUpdateStatus.error = action.payload;
    },


    // rental bills list start
    fetchrentalBillsListRequest: (state, action) => {
      state.rentalBillsList.loading = true;
      state.rentalBillsList.error = null;
    },
    fetchrentalBillsListSuccess: (state, action) => {
      state.rentalBillsList.data = action.payload;
      state.rentalBillsList.loading = false;
      state.rentalBillsList.error = null;
    },
    fetchrentalBillsListFailure: (state, action) => {
      state.rentalBillsList.data = null;
      state.rentalBillsList.loading = false;
      state.rentalBillsList.error = action.payload;
    },

    // rentalBills create
    rentalBillsCreateRequest: (state, action) => {
      state.rentalBillsCreate.loading = true;
      state.rentalBillsCreate.error = null;
    },
    rentalBillsCreateSuccess: (state, action) => {
      state.rentalBillsCreate.data = action.payload;
      state.rentalBillsCreate.loading = false;
      state.rentalBillsCreate.error = null;
      state.rentalBillsList = addNewRentalBillsListSuccess(
        action.payload,
        {
          ...state.rentalBillsList,
        }
      );
    },
    rentalBillsCreateFailure: (state, action) => {
      state.rentalBillsCreate.data = null;
      state.rentalBillsCreate.loading = false;
      state.rentalBillsCreate.error = action.payload;
    },

    // Update rental bills
    rentalBillsUpdateRequest: (state, action) => {
      state.rentalBillsUpdate.loading = true;
      state.rentalBillsUpdate.error = null;
    },
    rentalBillsUpdateSuccess: (state, action) => {
      state.rentalBillsUpdate.data = action.payload;
      state.rentalBillsUpdate.loading = false;
      state.rentalBillsUpdate.error = null;

      state.rentalBillsList = updateRentalBillsUpdateSuccess(
        action.payload,
        state.rentalBillsList
      );
    },
    rentalBillsUpdateFailure: (state, action) => {
      state.rentalBillsUpdate.data = null;
      state.rentalBillsUpdate.loading = false;
      state.rentalBillsUpdate.error = action.payload;
    },
  },
});

// addNewrentalInvoiceBills  Function
function addNewrentalInvoiceBillsSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}
// update function updaterentalInvoiceBillsSuccess
function updaterentalInvoiceBillsSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });
  return state;
}
// remove rental items
function removeRentalItem(dataToRemove, state) {
  state.data.data = state.data.data.map((item) => {
    if (item._id !== dataToRemove._id) return item;
    if (!item.length) return item;
    return { ...item, ...dataToRemove };
  });
  return state;
}
// updateRentalReportStatusSuccess
function updateRentalReportStatusSuccess(dataToUpdate, state) {
  state.data.data = [...dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}

// addNewrentalBills  Function
function addNewRentalBillsListSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}
// update function updaterentalBillsSuccess
function updateRentalBillsUpdateSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });
  return state;
}
export const {
  fetchrentalInvoiceBillsListRequest,
  fetchrentalInvoiceBillsListSuccess,
  fetchrentalInvoiceBillsListFailure,
  rentalInvoiceBillsCreateRequest,
  rentalInvoiceBillsCreateSuccess,
  rentalInvoiceBillsCreateFailure,
  rentalInvoiceBillsUpdateRequest,
  rentalInvoiceBillsUpdateSuccess,
  rentalInvoiceBillsUpdateFailure,
  rentalInvoiceBillsDeleteRequest,
  rentalInvoiceBillsDeleteSuccess,
  rentalInvoiceBillsDeleteFailure,
  rentalReportUpdateStatusRequest,
  rentalReportUpdateStatusSuccess,
  rentalReportUpdateStatusFailure,

  fetchrentalBillsListRequest,
  fetchrentalBillsListSuccess,
  fetchrentalBillsListFailure,
  rentalBillsCreateRequest,
  rentalBillsCreateSuccess,
  rentalBillsCreateFailure,
  rentalBillsUpdateRequest,
  rentalBillsUpdateSuccess,
  rentalBillsUpdateFailure
} = RentalBillsSlice.actions;

export const getRentalInvoiceBillsListState = (store) =>
  store.rentalBills.rentalInvoiceBillsList;
export const getRentalInvoiceBillsUpdateState = (store) =>
  store.rentalBills.rentalInvoiceBillsUpdate;

export const getRentalBillsListState = (store) =>
  store.rentalBills.rentalBillsList;

export const getRentalInvoiceBillsCreateState = (store) =>
  store.rentalBills.rentalInvoiceBillsCreate;

export default RentalBillsSlice.reducer;
